// api
import { authServerApiSlice } from '@/api/apiSlice';

export type SessionResponse = {
  authenticated?: boolean;
  claims?: {
    email?: string;
    name?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
};

export const sessionApiSlice = authServerApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSession: builder.query<SessionResponse, void>({
      query: () => '/me',
      providesTags: ['AuthServer'],
    }),
  }),
});

export const { useGetSessionQuery } = sessionApiSlice;
